module.exports = __webpack_public_path__ + "static/Robotic-Process-Automations-a0d1b39fb66caa54f99f418f0ac51950.jpg";